/* eslint-disable no-unused-vars */
import { useState } from 'react';
import { td } from '../theme';
import Ic from '../Icon';
export default function MxModal({ t, onClose, onOk }) {
  const [form, setForm] = useState({ title:'', cat:'Plumbing', pri:'medium', notes:'' });
  const set = (k,v) => setForm(f=>({...f,[k]:v}));
  const submit = () => {
    if(!form.title) return;
    onOk && onOk({ ...form, tid:t?.id, tenant_id:t?.id, u:t?.unit||t?.u, p:t?.property||t?.p, ten:t?.full_name||t?.name, date:td(), submitted_at:td(), st:'open', status:'open', upd:[{d:td(),m:'Request submitted.'}], maintenance_updates:[] });
    onClose();
  };
  return (
    <div className="mov" onClick={e=>e.target===e.currentTarget&&onClose()}>
      <div className="modal">
        <div className="mhd"><h2>New Maintenance Request</h2><button className="btn btn-gh" style={{padding:'5px 9px'}} onClick={onClose}><Ic n="x" s={15}/></button></div>
        <div className="mbdy">
          <div className="fg">
            <div className="fi fi-f"><label>Issue Title *</label><input value={form.title} onChange={e=>set('title',e.target.value)} placeholder="e.g. Leaky faucet in kitchen" autoFocus/></div>
            <div className="fi"><label>Category</label>
              <select value={form.cat} onChange={e=>set('cat',e.target.value)}>
                {['Plumbing','HVAC','Electrical','Appliance','Structural','Pest','Landscaping','Other'].map(c=><option key={c}>{c}</option>)}
              </select>
            </div>
            <div className="fi"><label>Priority</label>
              <select value={form.pri} onChange={e=>set('pri',e.target.value)}>
                <option value="low">Low</option><option value="medium">Medium</option><option value="high">High</option>
              </select>
            </div>
            <div className="fi fi-f"><label>Description</label><textarea value={form.notes} onChange={e=>set('notes',e.target.value)} placeholder="Describe the issue in detail..."/></div>
          </div>
          <div style={{display:'flex',gap:10,justifyContent:'flex-end',marginTop:8}}>
            <button className="btn btn-gh" onClick={onClose}>Cancel</button>
            <button className="btn btn-g" onClick={submit} disabled={!form.title}><Ic n="check" s={14}/>Submit Request</button>
          </div>
        </div>
      </div>
    </div>
  );
}
